import apolloClient from 'api/apolloClient';
import { GET_EMAILS_BY_PERIOD_ID, GET_EMAILS_BY_RANGE, GET_EMAIL_TYPES, GET_SEND_GRID_CONTEXT } from 'api/emailService';
import { makeAutoObservable } from 'mobx';
import { Email, EmailMapping, GeneralStatus, SendGridContext } from 'types/emailService';
import { PaginationDTO } from 'types/general';

export class EmailStore {
  // eslint-disable-next-line class-methods-use-this
  async getEmailsByPeriodId(periodId: string): Promise<EmailMapping[]> {
    const result = await apolloClient.query<{ getEmailsByPeriodId: EmailMapping[] }>({
      query: GET_EMAILS_BY_PERIOD_ID,
      fetchPolicy: 'no-cache',
      variables: { periodId },
    });
    return result.data.getEmailsByPeriodId;
  }

  // eslint-disable-next-line class-methods-use-this
  async getEmailsByRange(
    from: string,
    to: string,
    sponsorId: string,
    emailType: string,
    status: GeneralStatus | null,
    page: number,
    email = '',
  ): Promise<PaginationDTO<Email>> {
    const res = await apolloClient.query<{ getEmailsByRange: PaginationDTO<Email> }>({
      query: GET_EMAILS_BY_RANGE,
      fetchPolicy: 'no-cache',
      variables: { from, to, domainId: sponsorId, emailType, status, page, email },
    });
    return res.data.getEmailsByRange;
  }

  // eslint-disable-next-line class-methods-use-this
  async getEmailTypes(): Promise<string[]> {
    const res = await apolloClient.query<{ getEmailTypes: string[] }>({
      query: GET_EMAIL_TYPES,
    });
    return res.data.getEmailTypes;
  }

  // eslint-disable-next-line class-methods-use-this
  async getSendGridContext(id: string): Promise<SendGridContext> {
    const res = await apolloClient.query<{ getSendGridContext: SendGridContext }>({
      query: GET_SEND_GRID_CONTEXT,
      fetchPolicy: 'no-cache',
      variables: { id },
    });
    return res.data.getSendGridContext;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
